import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FlareXmlEditorModule } from '@portal-core/project-files/components/flare-xml-editor/flare-xml-editor.module';
import { ProjectFileGitbarModule } from '@portal-core/project-files/components/project-file-gitbar/project-file-gitbar.module';
import { ProjectFilesAccessErrorMessageModule } from '@portal-core/project-files/components/project-files-access-error-message/project-files-access-error-message.module';
import { ProjectFlareFileComponent } from './project-flare-file.component';

@NgModule({
  declarations: [
    ProjectFlareFileComponent
  ],
  imports: [
    CommonModule,
    FlareXmlEditorModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    ProjectFileGitbarModule,
    ProjectFilesAccessErrorMessageModule
  ],
  exports: [
    ProjectFlareFileComponent
  ]
})
export class ProjectFlareFileModule { }
